'use client';

import { action, makeObservable, observable } from 'mobx';

export class Store {
  loader = false;

  constructor() {
    makeObservable(this, {
      loader: observable,
      setLoader: action.bound,
    });
  }

  setLoader(value: boolean) {
    this.loader = value;
  }
}

export const store = new Store();
